import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Device } from 'src/app/models/device.model';
import { ContractType } from 'src/app/models/enums/contract-type.enum';
import { CustomMessage, mapMessage } from 'src/app/models/enums/custom-message.enum';
import { OperationMode } from 'src/app/models/enums/operation-mode.enum';
import { SharedService } from 'src/app/services/shared-service/shared.service';
import { CargoPaymentInfo } from '../../../models/cargo-payment-info.model';

@Component({
  selector: 'app-contract-acceptance',
  templateUrl: './contract-acceptance.component.html',
  styleUrls: ['./contract-acceptance.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ContractAcceptanceComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  currentContinueClick = false;
  @Input() cargoPaymentInfo?: CargoPaymentInfo;
  isHidden = '';
  isDescriptionHidden = false;
  currentErrorCreditCard = false;
  isSignatureObject1 = false;
  isSignatureObject2 = false;
  currentCanceledByUser = false;
  currentPaymentType = '';
  currentSelectedIpad: Device | null = null;
  isNoSignatureNoPaymentScenario = false;
  isCustomTimeoutError = false;
  contractSectionExpanded = false;

  constructor(private sharedService: SharedService, private cdr: ChangeDetectorRef) {
    // Initialize derived values in constructor to avoid change detection issues
    this.isHidden = '';
    this.isDescriptionHidden = false;
  }

  ngOnInit(): void {
    this.sharedService.currentSelectedIpad.pipe(takeUntil(this.destroy$)).subscribe((selectedIpad) => {
      this.currentSelectedIpad = selectedIpad;
      this.cdr.markForCheck();
    });

    this.sharedService.currentContinueClick.pipe(takeUntil(this.destroy$)).subscribe((isContinueClick) => {
      this.currentContinueClick = isContinueClick;
      this.cdr.markForCheck();
    });

    this.sharedService.currentErrorCreditCard.pipe(takeUntil(this.destroy$)).subscribe((isErrorCreditCard) => {
      this.currentErrorCreditCard = isErrorCreditCard;
      this.cdr.markForCheck();
    });

    this.sharedService.currentSignatureObject1.pipe(takeUntil(this.destroy$)).subscribe((isSignatureObject1) => {
      this.isSignatureObject1 = isSignatureObject1;
      this.cdr.markForCheck();
    });

    this.sharedService.currentSignatureObject2.pipe(takeUntil(this.destroy$)).subscribe((isSignatureObject2) => {
      this.isSignatureObject2 = isSignatureObject2;
      this.cdr.markForCheck();
    });

    this.sharedService.currentCanceledByUser.pipe(takeUntil(this.destroy$)).subscribe((canceledByUser) => {
      this.currentCanceledByUser = canceledByUser;
      this.cdr.markForCheck();
    });

    this.sharedService.currentPaymentType.pipe(takeUntil(this.destroy$)).subscribe((paymentType) => {
      this.currentPaymentType = paymentType;
      this.cdr.markForCheck();
    });

    this.isHiddenRadio();

    this.sharedService.currentIsNoSignatureNoPayment.pipe(takeUntil(this.destroy$)).subscribe((isNoPayNoSignatureScenario) => {
      this.isNoSignatureNoPaymentScenario = isNoPayNoSignatureScenario;
      this.cdr.markForCheck();
    });

    this.sharedService.currentIsCustomTimeoutError.pipe(takeUntil(this.destroy$)).subscribe((isCustomTimeoutError) => {
      this.isCustomTimeoutError = isCustomTimeoutError;
      this.cdr.markForCheck();
    });

    this.sharedService.currentContractSectionExpanded.pipe(takeUntil(this.destroy$)).subscribe((isExpanded) => {
      this.contractSectionExpanded = isExpanded;
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onContractSelected(event: any) {
    this.sharedService.hideMessage();
    if (this.cargoPaymentInfo) {
      this.sharedService.updateContinueClick(false);
      this.sharedService.updateNextDisabled(false);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
      this.cargoPaymentInfo.signatureRequirement = ContractType[event.target.value];
      if (this.cargoPaymentInfo.signatureRequirement == 'NotRequired') {
        this.isDescriptionHidden = false;
      } else {
        this.isDescriptionHidden = true;
      }

      if (
        this.cargoPaymentInfo?.signatureRequirement === 'NotRequired' &&
        this.cargoPaymentInfo?.paymentAdviceAmount >= 0 &&
        !this.currentContinueClick
      ) {
        this.sharedService.showMessage(mapMessage.get(CustomMessage.WarnSignature));
      }
    }
  }

  isValidated(): boolean {
    return this.currentContinueClick && this.cargoPaymentInfo?.signatureRequirement == 'NotRequired' ? false : true;
  }

  isValidatedAmount(): boolean {
    return this.currentContinueClick &&
      this.cargoPaymentInfo?.signatureRequirement == 'NotRequired' &&
      this.cargoPaymentInfo?.paymentAdviceAmount <= 0
      ? true
      : false;
  }

  isCashOrCheck(): boolean {
    return this.currentContinueClick &&
      this.cargoPaymentInfo?.signatureRequirement == 'NotRequired' &&
      (this.cargoPaymentInfo?.operationMode == OperationMode.CQ || this.cargoPaymentInfo?.operationMode == undefined)
      ? true
      : false;
  }

  isHiddenRadio() {
    if (this.cargoPaymentInfo?.source.toLocaleLowerCase() == 'export' && this.cargoPaymentInfo?.isSSERequired.toLocaleLowerCase() == 'n')
      this.isHidden = 'AWB';
    else if (
      this.cargoPaymentInfo?.source.toLocaleLowerCase() == 'export' &&
      this.cargoPaymentInfo?.isSSERequired.toLocaleLowerCase() == 'y'
    )
      this.isHidden = 'AWBSecurity';
    else if (this.cargoPaymentInfo?.source.toLocaleLowerCase() == 'import') this.isHidden = 'Delivery';
  }
}
